import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-popup_close",
  "use": "icon-popup_close-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-popup_close\"><path d=\"m15.15 12.017 8.197-8.209c.87-.871.87-2.283 0-3.155a2.225 2.225 0 0 0-3.15 0L12 8.862 3.803.658a2.225 2.225 0 0 0-3.15 0 2.233 2.233 0 0 0 0 3.154l8.197 8.209-8.164 8.171a2.233 2.233 0 0 0 0 3.155c.87.87 2.28.87 3.15 0L12 15.175l8.16 8.172c.87.87 2.28.87 3.15 0 .87-.872.87-2.284 0-3.155l-8.16-8.175z\" fill=\"#4d4d4d\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol